<template>
<div class="container">
<b-row v-if="!isLoading">
<h3>
	<label for="desde">Desde</label> &nbsp;
	<input type="date" name="" id="desde" v-model="desde" @click="desde='';hasta='';pais='';paises=false;fgl_mensaje=false;">&nbsp; 
	<label for="hasta">Hasta</label> &nbsp;
	<input type="date" name="" id="hasta" v-model="hasta" @click="hasta='';pais='';paises=false" @input="f_seleccione_pais()">&nbsp; 
	<label v-if="paises">País</label>
	<select v-if="paises" v-model="pais" @click="f_traiga_informacion()">
		<option
			v-for="(item, idx) in listPaises"
			:key="idx"
			:value="item.pais">
			{{item.pais}}
		</option>
	</select>
</h3>
<b-container v-if="listCruce.length >0">
	<md-table >
		<h1 class="md-title"><b><i>{{f_titulo()}}</i></b></h1>
	</md-table>
	<md-table v-model="listCruce" md-card md-fixed-header @md-selected="f_genere_excel">
	<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
		<md-table-cell :md-label="labels.orden" class="text-center border"><h5>{{item.orden}}</h5></md-table-cell>
		<md-table-cell :md-label="labels.descripcion" class="text-left border"><h5>{{item.descripcion}}</h5></md-table-cell>
		<md-table-cell :md-label="labels.cantidad" class="text-right border"><h5>{{formato(item.cantidad)}}</h5></md-table-cell>
	</md-table-row>
	</md-table>
	<md-table v-if="genereExcel==true">
	<md-table-row >
		<md-table-cell class="text-center border"><h5>{{excel}}</h5></md-table-cell>
	</md-table-row>
	</md-table>
</b-container>
</b-row>
</div>
</template>
<script>
import Seguimiento from "@/services/Seguimiento"
import User from "@/services/User"
import Estado from "@/services/Estados"
import * as XLSX from "exceljs"

export default {
name:'Conciliacion',
data: () => ({
	isLoading: false,
	Fecha : false,
	Lider : false,
	Usuario : false,
	opcion: 0,
	operacion: '',
	factura: '',
	pais: '',
	paises: false,
	titulo_factura: "",
	titulo_estado: "",
	users : [],
	listEstados : [],
	listPaises : [],
	listCruce : [],
	listDetalle : [],
	desde: '',
	hasta: '',
	recarga: '',
	genereExcel: false,
	excel:'',
	reporte:'',
}),
computed:{
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			title : "FACTURAS",
			orden : "Orden",
			descripcion : "Descripcion",
			cantidad : "Cantidad",
		}
	}else{
		return {
			title : "INVOICES",
			factura : "Invoice",
			fecha : "Date",
			identificacion : "Identification",
			proveedor : "Name",
			cantidad : "Invoices",
			pedido : "Order",
			valor : "Amount",
			impuesto0 : "Tax0",
			categoria0 : "Category0",
			impuesto1 : "Tax1",
			categoria1 : "Category1",
			impuesto2 : "Tax2",
			categoria2 : "Category2",
			impuesto : "Taxes",
			valor_total : "Total Amount",
			items : "Items",
			estado: "Condition",
			lider: "Leader",
			lider_nombre: "Leader Name",
			usuario: "User",
			usuario_nombre: "User Name",
		}
	}
}
},
mounted(){
	User.getAllUsers(this.$store.state.userName)
	.then((result) => {
		this.users = result.data.users;
	})
	.catch((err) => {
		console.log(err)
	})
	Seguimiento.leaTodosPaises()
	.then((res) => {
		this.listPaises = res.data.listPaises
		this.pais=''
		if	(this.listPaises.lenght>0) {
			this.paises=true
		}
	})
	.catch((err) => {
		console.log(err)
	})
	Estado.leaEstados(false)
	.then((result) => {
		this.listEstados = result.data.listEstados;
	})
	.catch((err) => {
		console.log(err)
	})
},
methods:{
	f_titulo() {
		return "CONCILIACION INFORMACION DESDE "+
			this.desde+" HASTA "+this.hasta
	},
	f_muestra_detalle(r_factura) {
		this.factura=r_factura
	},
	f_usuario_nombre(p_id) {
		if	(p_id === null) {
			return ""
		}
		const v_usuario=this.users.find((r_usuario) => r_usuario.id==p_id
						)
		return v_usuario.name
	},
	f_traiga_informacion() {
		
		Seguimiento.informacionConciliacion(this.pais,this.desde,this.hasta)
		.then((res) => {
			this.listCruce = res.data.listCruce
			if	(this.listCruce.length==0) {
				this.$toast.error("No existen registros para la consulta")		
			}
		})
		.catch((err) => {
			console.log(err)
		})
	},
	f_seleccione_pais() {
		this.paises = true
	},
	formato(numero) {
		return  new Intl.NumberFormat('en-US',{ maximumFractionDigits: 0}).format(numero)
	},
	f_genere_excel(reporte) {
		if	(reporte == "null") {
			return
		}
		this.genereExcel=false
		if	(reporte.orden <= 4) {
			this.genereExcel=true
			this.excel= "Generando excel para "+reporte.descripcion
			this.reporte= reporte.descripcion
			Seguimiento.conciliaDetalle(this.pais,this.desde,this.hasta,reporte.orden)
			.then((res) => {
				this.listDetalle = res.data.listDetalle[0]
			})
			.then(() => {
				this.excelConcilia()
			})
			.then(() => {
				this.genereExcel=false
			})
		}
	},

	async excelConcilia() {
		let createdAt1 = new Date()
		let anio = createdAt1.getFullYear()
		let mes = createdAt1.getMonth()+1
		let dia = createdAt1.getDate()
		let createdAt = anio+"-"+mes+"-"+dia

		let titulo = this.reporte+" "+this.pais+
			" INFORMACION DESDE "+this.desde+
			" HASTA "+this.hasta
		let userName = this.$store.state.userName

		const {Workbook} = XLSX
		const workbook = new Workbook()
		const worksheet = workbook.addWorksheet("Concilia")

		const ENCABEZADO1 = [
			titulo
		]
		worksheet.addRow(ENCABEZADO1)
		const ENCABEZADO3 = [
			"Creado "+createdAt+" por "+userName,
		]
		worksheet.addRow(ENCABEZADO3)
		const ENCABEZADO5 = [
		]
		worksheet.addRow(ENCABEZADO5)
		
		const HEADER_ROW = [
			"Factura",
			"Identificacion",
			"Nombre",
		]
		worksheet.addRow(HEADER_ROW)
		
		this.listDetalle.forEach((factura) => {
			const v_fila = [
				factura.factura,
				factura.identificacion,
				factura.nombre,
			]
			worksheet.addRow(v_fila)
		})

		const file = await workbook.xlsx.writeBuffer()
		const downloadLink = document.createElement("a")
		downloadLink.download = this.reporte+" "+this.desde+"-"+this.hasta+".xlsx"
		downloadLink.href = window.URL.createObjectURL(
			new Blob([file], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			})
		)

		downloadLink.style.display = "none";

		document.body.appendChild(downloadLink);
		downloadLink.click();

		downloadLink.remove();
		
	},
}

}
</script>

<style>
table {
	table-layout:fixed;
}
.md-table-fixed-header-active {
	border-bottom: 20px solid;
}

</style>
